/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Extra details for DeviceGroupType=ScheduledMaintenance
 * @export
 * @interface DeviceGroupScheduledMaintenanceConfigDto
 */
export interface DeviceGroupScheduledMaintenanceConfigDto {
    /**
     *
     * @type {string}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    serviceInterval?: DeviceGroupScheduledMaintenanceConfigDtoServiceIntervalEnum;
    /**
     * Number of days before scheduled date to create tickets
     * @type {number}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    leadTimeDays?: number;
    /**
     *
     * @type {Date}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    startDate?: Date;
    /**
     *
     * @type {Date}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    endDate?: Date;
    /**
     * Optional description of the scheduled maintenance config
     * @type {string}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    description?: string;
    /**
     * Populated from SiteDeviceGroup.DeviceGroupTag
     * @type {string}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    siteDeviceGroupTag?: string;
    /**
     * Populated from SiteDeviceGroup.DeviceGroupName
     * @type {string}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    siteName?: string;
    /**
     * The contractor assigned to this scheduled maintenance group
     * @type {string}
     * @memberof DeviceGroupScheduledMaintenanceConfigDto
     */
    contractor?: string;
}

/**
 * @export
 */
export const DeviceGroupScheduledMaintenanceConfigDtoServiceIntervalEnum = {
    Unknown: "Unknown",
    Monthly: "Monthly",
    Quarterly: "Quarterly",
    SemiAnnually: "SemiAnnually",
    Annually: "Annually",
} as const;
export type DeviceGroupScheduledMaintenanceConfigDtoServiceIntervalEnum =
    (typeof DeviceGroupScheduledMaintenanceConfigDtoServiceIntervalEnum)[keyof typeof DeviceGroupScheduledMaintenanceConfigDtoServiceIntervalEnum];

/**
 * Check if a given object implements the DeviceGroupScheduledMaintenanceConfigDto interface.
 */
export function instanceOfDeviceGroupScheduledMaintenanceConfigDto(
    value: object,
): value is DeviceGroupScheduledMaintenanceConfigDto {
    return true;
}

export function DeviceGroupScheduledMaintenanceConfigDtoFromJSON(
    json: any,
): DeviceGroupScheduledMaintenanceConfigDto {
    return DeviceGroupScheduledMaintenanceConfigDtoFromJSONTyped(json, false);
}

export function DeviceGroupScheduledMaintenanceConfigDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceGroupScheduledMaintenanceConfigDto {
    if (json == null) {
        return json;
    }
    return {
        serviceInterval:
            json["serviceInterval"] == null
                ? undefined
                : json["serviceInterval"],
        leadTimeDays:
            json["leadTimeDays"] == null ? undefined : json["leadTimeDays"],
        startDate:
            json["startDate"] == null ? undefined : new Date(json["startDate"]),
        endDate:
            json["endDate"] == null ? undefined : new Date(json["endDate"]),
        description:
            json["description"] == null ? undefined : json["description"],
        siteDeviceGroupTag:
            json["siteDeviceGroupTag"] == null
                ? undefined
                : json["siteDeviceGroupTag"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        contractor: json["contractor"] == null ? undefined : json["contractor"],
    };
}

export function DeviceGroupScheduledMaintenanceConfigDtoToJSON(
    value?: DeviceGroupScheduledMaintenanceConfigDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        serviceInterval: value["serviceInterval"],
        leadTimeDays: value["leadTimeDays"],
        startDate:
            value["startDate"] == null
                ? undefined
                : value["startDate"].toISOString(),
        endDate:
            value["endDate"] == null
                ? undefined
                : value["endDate"].toISOString(),
        description: value["description"],
        siteDeviceGroupTag: value["siteDeviceGroupTag"],
        siteName: value["siteName"],
        contractor: value["contractor"],
    };
}
